<template>
  <div class="mains">
    <div class="campus">
      小程序管理
      <span>></span>小程序界面
    </div>
    <div class="xiaoqu">
      <el-card :span="24">
        <div class="grid-content">
          <div class="xiaoqu_1">程序选择</div>
          <div class="huanse">
            您可在此处进行小程序的切换，对不同的小程序的界面进行设置
          </div>
          <div class="xcxgh">
            <div class="xcx_mc">
              小程序名称：{{ xcx_name }}
              <div class="xcx_an" v-if="xcx_bt">
                <el-button v-if="xcx_lists.length>1" size="small" type="primary" @click="geng_hua_xcx">
                  更换小程序
                </el-button>
              </div>
            </div>
            <div class="xcx_xq">
            </div>
          </div>
        </div>
      </el-card>
      <!-- <el-card :span="24">
        <div class="grid-content">
          <div class="xiaoqu_1">颜色设置</div>
          <div class="huanse">
            可设定小程序用户端的视觉色系，请在以下色卡选项中选择您想要的背景
            <span>（可用鼠标点击色块预览实际应用效果）</span>
          </div>
          <div class="ysxz">
            <div
              class="yanse yanse1"
              :class="item.class"
              @click="bianse(item)"
              v-for="(item,index) in list"
              :key="index"
            >
              <div class="img1">
                <img v-if="yan == item.id" :src="item.coerImg" alt />
              </div>
              <span>{{ item.name }}</span>
            </div>
          </div>

          <div class="zsbg zsbg_2"></div>
        </div>
      </el-card> -->
    </div>

    <div class="xiaoqu">
      <el-card :span="24">
        <div class="grid-content">
          <el-dialog title="更换小程序" :visible.sync="addStudents">
            <div class="form_1 form_1_1 xcx_genghuan">
              <el-form ref="Trialscope" :model="Trialscopes" :rules="FormRules" label-width="5.20833vw">
                <el-form-item label="小程序名称" prop="name" class="fanwei0">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" />
                  </i>
                  <!-- <el-dropdown>
                    <el-button type="primary" class="xuanze1">
                      {{ xcx_gh }}
                      <i class="el-icon-arrow-down el-icon--right lbt_i_img"></i>
                    </el-button>
                    <el-dropdown-menu class="dropdownss dropdown_xcx" slot="dropdown">
                      <el-dropdown-item @click.native="guanli4(item)" v-for="(item, index) in xcx_lists" :key="index">
                        {{ item.name }}
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown> -->
                  <el-select v-model="xcx_gh_id" placeholder="请选择">
                    <el-option v-for="(item,index) in xcx_lists" :key="index" :label="item.name" :value="item.id"
                      @click.native="xcx_gh = item.name">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="queding">
                  <el-button type="primary" @click="qd_shiyong">
                    确定
                  </el-button>
                  <el-button @click="quxiao0">取消</el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-dialog>

          <div class="xiaoqu_1">上传设置</div>
          <div class="huanse">
            <span>您可自行上传小程序页面中可修改的视觉区域（如banner及功能区域的视觉区域）</span><br />
            <span>修改后请到学生端小程序查看效果！</span>

          </div>
          <!-- <div class="kaiqi">
            <el-switch v-model="value" active-color="#13ce66" inactive-color="#ff4949" @change="updateMiniInfoPageSet"></el-switch>启用界面修改设置
          </div> -->

          <el-dialog title="添加选项" :visible.sync="addBanner_s" width="600px">
            <div class="form_1 form_1_1">
              <el-form ref="forms" :model="forms2" :rules="FormRules" label-width="5.20833vw">
                <el-form-item label="轮播图命名" prop="invite_code">
                  <i>
                    <img src="@/assets/img/education-manage/campus/bitian.png" class="wuzi" alt />
                  </i>
                  <el-input v-model="forms2.banner_name" placeholder="请输入轮播图名称"></el-input>
                </el-form-item>
                <el-form-item class="queding">
                  <el-button type="primary" @click="addBanner">确定</el-button>
                  <el-button @click="quxiao">取消</el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-dialog>

          <div class="zsbg zsbg_2">
            <el-row>
              <el-col :span="6">
                <div class="grid-content bg-purple shouji_cx">
                  <img src="@/assets/img/small-program-manage/xcx.png" alt />
                </div>
              </el-col>

              <el-col :span="18" class="right">
                <div class="grid-content bg-purple-light">
                  <el-tabs type class="tabs_1" @tab-click="handleClick">
                    <el-tab-pane label="轮播图区域">
                      <div class="zi_xuigai">
                        自定义修改：
                        <span>（点击上传按钮进行自定义内容的上传，编辑自定义属性，左边预览实际生成效果，打开启用页面修改设置即对小程序生效）</span>
                      </div>
                      <div class="form_1 form_1_1 qiehuan_lbt">
                        <el-form ref="forms" :model="form" :rules="FormRules" label-width="5.20833vw">
                          <el-form-item label="轮播图" prop="name">
                            <i>
                              <img src="@/assets/img/education-manage/campus/bitian.png" class="sangezi" alt />
                            </i>
                            <el-dropdown>
                              <el-button type="primary" class="xuanze1">
                                {{ xuanze1 }}
                                <i class="el-icon-arrow-down el-icon--right lbt_i_img"></i>
                              </el-button>
                              <el-dropdown-menu class="dropdownss dropdown_lbt" slot="dropdown">
                                <el-dropdown-item @click.native="guanli(item)" v-for="(item, index) in bannerList" :key="index">
                                  {{ item.name }}</el-dropdown-item>
                              </el-dropdown-menu>
                            </el-dropdown>
                            <el-button class="tianjia_banner" type="primary" @click="addBanner_1">
                              <span>+</span> 添加选项
                            </el-button>
                          </el-form-item>

                          <el-form-item class="shangchuan_lbt" label="上传图片" prop="name">
                            <i>
                              <img src="@/assets/img/education-manage/campus/bitian.png" class="lbt_shang" alt />
                            </i>
                            <el-upload class="avatar-uploader" action="#" :show-file-list="false" :http-request="handleAvatarSuccess"
                              :before-upload="beforeAvatarUpload">
                              <img v-if="tempImg" :src="tempImg" class="avatar" />
                              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                            <el-upload action="#" :show-file-list="false" :http-request="handleAvatarSuccess"
                              :before-upload="beforeAvatarUpload" class="lbt_item">
                              <el-button size="small" type="primary" class="genghuan_lbt lbt_btn">更换轮播图</el-button>
                            </el-upload>
                            <span class="genghuan_lbt lbt_span1">( 建议：JPG或PNG图片， 推荐：900*500px )</span>
                          </el-form-item>
                          <!-- <el-form-item label="是否启用" prop="name">
                            <i>
                              <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                            </i>
                            <span class="qiyong">
                              <el-switch v-model="value1" active-color="#13ce66" inactive-color="#ff4949" @change="updateMiniInfoBannerSet"></el-switch>
                              <span>开启</span>
                              (
                              此启用为启用子开关，开启后，上传效果将实际应用到用户小程序中
                              )
                            </span>
                          </el-form-item> -->
                          <el-form-item class="queding_xuigai">
                            <el-button type="primary" :loading="loading_1" @click="modificatio1">确定修改</el-button>
                          </el-form-item>
                        </el-form>
                      </div>
                    </el-tab-pane>

                    <el-tab-pane label="功能模块区域">
                      <div class="zi_xuigai">
                        自定义修改：
                        <span>（点击上传按钮进行自定义内容的上传，编辑自定义属性，左边预览实际生成效果，打开启用页面修改设置即对小程序生效）</span>
                      </div>
                      <div class="form_1 form_1_1 qiehuan_lbt">
                        <el-form ref="forms" :model="form" :rules="FormRules" label-width="5.20833vw">
                          <el-form-item label="功能模块" prop="name">
                            <i>
                              <img src="@/assets/img/education-manage/campus/bitian.png" class alt />
                            </i>
                            <el-dropdown>
                              <el-button type="primary" class="xuanze1">
                                {{ xuanze2 }}
                                <i class="el-icon-arrow-down el-icon--right lbt_i_img"></i>
                              </el-button>
                              <el-dropdown-menu class="dropdownss dropdown_lbt" slot="dropdown">
                                <el-dropdown-item @click.native="guanli1(item)" v-for="(item, index) in modelList" :key="index">
                                  {{ item.name }}
                                </el-dropdown-item>
                              </el-dropdown-menu>
                            </el-dropdown>
                          </el-form-item>

                          <el-form-item class="shangchuan_lbt" label="上传图片" prop="name">
                            <i>
                              <img src="@/assets/img/education-manage/campus/bitian.png" class="lbt_shang" alt />
                            </i>
                            <el-upload class="avatar-uploader" action="#" :show-file-list="false" :before-upload="beforeAvatarUpload"
                              :http-request="handleAvatarSuccess1">
                              <img v-if="tempImg1" :src="tempImg1" class="avatar1" />
                              <i v-else class="el-icon-plus avatar-uploader-icon1"></i>
                            </el-upload>
                            <el-upload action="#" :show-file-list="false" :http-request="handleAvatarSuccess1"
                              :before-upload="beforeAvatarUpload" class="lbt_item">
                              <el-button size="small" type="primary" class="genghuan_gnk lbt_btn">更换功能块</el-button>
                            </el-upload>
                            <span class="genghuan_gnk lbt_span1">( 建议：JPG或PNG图片， 推荐：250*250px )</span>
                          </el-form-item>
                          <!-- <el-form-item label="是否启用" prop="name">
                            <i>
                              <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                            </i>
                            <span class="qiyong">
                              <el-switch v-model="value2" active-color="#13ce66" inactive-color="#ff4949" @change="updateMiniInfoModuleSet">
                              </el-switch>
                              <span>开启</span>
                              (
                              此启用为启用子开关，开启后，上传效果将实际应用到用户小程序中
                              )
                            </span>
                          </el-form-item> -->
                          <el-form-item class="queding_xuigai">
                            <el-button type="primary" :loading="loading_2" @click="modificatio2">确定修改</el-button>
                          </el-form-item>
                        </el-form>
                      </div>
                    </el-tab-pane>

                    <!-- <el-tab-pane label="扩展模块区域">
                      <div class="zi_xuigai">
                        自定义修改：
                        <span>（点击上传按钮进行自定义内容的上传，编辑自定义属性，左边预览实际生成效果，打开启用页面修改设置即对小程序生效）</span>
                      </div>
                      <div class="form_1 form_1_1 qiehuan_lbt">
                        <el-form ref="forms" :model="form" :rules="FormRules" label-width="5.20833vw">
                          <el-form-item label="功能模块" prop="name">
                            <i>
                              <img src="@/assets/img/education-manage/campus/bitian.png" class alt />
                            </i>
                            <el-dropdown>
                              <el-button type="primary" class="xuanze1">
                                {{ xuanze3 }}
                                <i class="el-icon-arrow-down el-icon--right lbt_i_img"></i>
                              </el-button>
                              <el-dropdown-menu class="dropdownss dropdown_lbt" slot="dropdown">
                                <el-dropdown-item @click.native="guanli2(item)" v-for="(item, index) in extensionList" :key="index">
                                  {{ item.name }}</el-dropdown-item>
                              </el-dropdown-menu>
                            </el-dropdown>
                          </el-form-item>

                          <el-form-item class="shangchuan_lbt" label="上传图片" prop="name">
                            <i>
                              <img src="@/assets/img/education-manage/campus/bitian.png" class="lbt_shang" alt />
                            </i>
                            <el-upload class="avatar-uploader" action="#" :show-file-list="false" :before-upload="beforeAvatarUpload"
                              :http-request="handleAvatarSuccess2">
                              <img v-if="tempImg2" :src="tempImg2" class="avatar" />
                              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                            <el-upload action="#" :show-file-list="false" :http-request="handleAvatarSuccess2"
                              :before-upload="beforeAvatarUpload" class="lbt_item">
                              <el-button size="small" type="primary" class="genghuan_lbt lbt_btn">更换扩展块</el-button>
                            </el-upload>
                            <span class="genghuan_lbt lbt_span1">( 建议：JPG或PNG图片， 推荐：250*250px )</span>
                          </el-form-item>
                          <el-form-item label="是否启用" prop="name">
                            <i>
                              <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                            </i>
                            <span class="qiyong">
                              <el-switch v-model="value3" active-color="#13ce66" inactive-color="#ff4949"
                                @change="updateMiniInfoExtensionSet"></el-switch>
                              <span>开启</span>
                              (
                              此启用为启用子开关，开启后，上传效果将实际应用到用户小程序中
                              )
                            </span>
                          </el-form-item>
                          <el-form-item class="queding_xuigai">
                            <el-button type="primary" :loading="loading_3" @click="modificatio3">确定修改</el-button>
                          </el-form-item>
                        </el-form>
                      </div>
                    </el-tab-pane> -->
                  </el-tabs>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'minifirstpage',
  data() {
    return {
      FormRules: {},
      list: [
        {
          id: 1,
          coerImg: require('@/assets/img/small-program-manage/duigou.png'),
          yan: true,
          class: 'zi',
          name: '锦葵紫',
          color: '#8138f4',
        },
        {
          id: 2,
          coerImg: require('@/assets/img/small-program-manage/duigou.png'),
          yan: false,
          class: 'hong',
          name: '海棠红',
          color: '#f73c4e',
        },
        {
          id: 3,
          coerImg: require('@/assets/img/small-program-manage/duigou.png'),
          yan: false,
          class: 'lan',
          name: '甘梅蓝',
          color: '#00a6e6',
        },
        {
          id: 4,
          coerImg: require('@/assets/img/small-program-manage/duigou.png'),
          yan: false,
          class: 'huang',
          name: '樱草黄',
          color: '#ffc41f',
        },
        {
          id: 5,
          coerImg: require('@/assets/img/small-program-manage/duigou.png'),
          yan: false,
          class: 'bilan',
          name: '碧蓝色',
          color: '#07d3cd',
        },
        {
          id: 6,
          coerImg: require('@/assets/img/small-program-manage/duigou.png'),
          yan: false,
          class: 'cheng',
          name: '黄栌色',
          color: '#ff6a36',
        },
        {
          id: 7,
          coerImg: require('@/assets/img/small-program-manage/duigou.png'),
          yan: false,
          class: 'lianlan',
          name: '道奇蓝',
          color: '#3d7dfd',
        },
        {
          id: 8,
          coerImg: require('@/assets/img/small-program-manage/duigou.png'),
          yan: false,
          class: 'lv',
          name: '松花绿',
          color: '#71d311',
        },
      ],
      form: {},
      yan: '',
      value: '',
      value1: '',
      value2: '',
      value3: '',
      values: '',
      value1s: '',
      value2s: '',
      value3s: '',
      id: '',
      xuanze1: '轮播图banner 一',
      xuanze2: '',
      xuanze3: '',
      id_xuanze1: '',
      id_xuanze2: '',
      id_xuanze3: '',
      xcx_gh: '',
      xcx_gh_id: '',
      type_xuanze1: '',
      type_xuanze2: '',
      type_xuanze3: '',
      bannerList: [],
      modelList: [],
      extensionList: [],
      tempImg: '',
      tempImg1: '',
      tempImg2: '',
      loading_1: false,
      loading_2: false,
      loading_3: false,
      forms2: {
        banner_name: '',
      },
      addBanner_s: false,
      xcx_lists: [],
      xcx_bt: true,
      xcx_name: '新飞跃在线',
      xcx_id: '',
      addStudents: false,
      Trialscopes: {},
    };
  },
  created() {
    // this.getMiniBannerByOrgId()

    let orgid = window.sessionStorage.getItem('orgid');
    let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
    let pro = this.$http({
      url: '/mini/miniInfo/getMiniInfo/' + orgid,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token,
      },
    });
    pro
      .then((result) => {
        console.log(result);
        if (result.data.code !== 0) {
          return this.$message.error(result.data.message);
        }
        this.xcx_lists = result.data.data;
        if (this.xcx_lists.length === 1) {
          this.xcx_bt = true;
        }
        this.xcx_name = this.xcx_lists[0].name;
        this.xcx_gh = this.xcx_lists[0].name;
        this.xcx_id = this.xcx_lists[0].id;
        this.xcx_gh_id = this.xcx_lists[0].id;
        if (this.xcx_id !== '') {
          this.jiemian();
        }
      })
      .catch((err) => {
        // console.log('error===============')
        this.$message.error('上传图片错误：' + err);
      });
  },
  methods: {
    geng_hua_xcx() {
      // console.log('e')
      this.addStudents = true;
      this.xcx_gh = this.xcx_name;
      this.xcx_gh_id = this.xcx_id;
    },
    qd_shiyong() {
      this.xcx_name = this.xcx_gh;
      this.xcx_id = this.xcx_gh_id;
      this.addStudents = false;
      if (this.xcx_id !== '') {
        this.jiemian();
      }
    },
    quxiao0() {
      this.addStudents = false;
    },

    handleClick() {},
    handleAvatarSuccess(data) {
      // console.log(data.file)
      let orgid = window.sessionStorage.getItem('orgid');
      let formData = new FormData();
      formData.append('file', data.file);
      formData.append('orgid', orgid);
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/mini/miniInfo/uploadimage',
        method: 'POST',
        data: formData,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code === 0) {
            let url = result.data.data;
            this.tempImg = url;
          } else {
            this.$message.error(result.data.message);
          }
        })
        .catch((err) => {
          // console.log('error===============')
          this.$message.error('上传图片错误：' + err);
        });
    },

    handleAvatarSuccess1(data) {
      // console.log(data.file)
      let orgid = window.sessionStorage.getItem('orgid');
      let formData = new FormData();
      formData.append('file', data.file);
      formData.append('orgid', orgid);
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/mini/miniInfo/uploadimage',
        method: 'POST',
        data: formData,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code === 0) {
            let url = result.data.data;
            // console.log('result.data.url=======================' + url)
            this.tempImg1 = url;
          } else {
            this.$message.error(result.data.message);
          }
        })
        .catch((err) => {
          // console.log('error===============')
          this.$message.error('上传图片错误：' + err);
        });
    },

    handleAvatarSuccess2(data) {
      // console.log(data.file)
      let orgid = window.sessionStorage.getItem('orgid');
      let formData = new FormData();
      formData.append('file', data.file);
      formData.append('orgid', orgid);
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/mini/miniInfo/uploadimage',
        method: 'POST',
        data: formData,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code === 0) {
            let url = result.data.data;
            // console.log('result.data.url=======================' + url)
            this.tempImg2 = url;
          } else {
            this.$message.error(result.data.message);
          }
        })
        .catch((err) => {
          // console.log('error===============')
          this.$message.error('上传图片错误：' + err);
        });
    },

    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 1;

      if (!isJPG && !isPNG) {
        this.$message.error('上传图片只能是 JPG/PNG 格式!');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 1MB!');
        return false;
      }
      return isJPG | isPNG && isLt2M;
    },

    // 查询设置信息
    jiemian() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let xcxid = this.xcx_id;
      let pro = this.$http({
        url: '/mini/miniInfo/selectMiniInfoByMiniid/' + xcxid + '?orgid=' + orgid,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          console.log(result, 'selectMiniInfoByMiniid');
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.bannerList = result.data.data.bannerList;
          if (this.bannerList.length === 0) {
            this.xuanze1 = '';
            this.id_xuanze1 = '';
            this.type_xuanze1 = '';
            this.tempImg = '';
          }
          if (this.bannerList.length > 0) {
            if (this.bannerList[0].name !== '') {
              // console.log('bannerList')
              this.xuanze1 = this.bannerList[0].name;
              this.id_xuanze1 = this.bannerList[0].id;
              this.type_xuanze1 = this.bannerList[0].type;
              this.tempImg = this.bannerList[0].picurl;
            }
          }
          this.modelList = result.data.data.modelList;
          if (this.modelList.length === 0) {
            this.xuanze2 = '';
            this.id_xuanze2 = '';
            this.type_xuanze2 = '';
            this.tempImg1 = '';
          }
          if (this.modelList.length > 0) {
            if (this.modelList[0].name !== '') {
              this.xuanze2 = this.modelList[0].name;
              this.id_xuanze2 = this.modelList[0].id;
              this.type_xuanze2 = this.modelList[0].type;
              this.tempImg1 = this.modelList[0].picurl;
            }
          }
          this.extensionList = result.data.data.extensionList;
          if (this.extensionList.length === 0) {
            this.xuanze3 = '';
            this.id_xuanze3 = '';
            this.type_xuanze3 = '';
            this.tempImg2 = '';
          }
          if (this.extensionList.length > 0) {
            if (this.extensionList[0].name !== '') {
              // console.log('extensionList')
              this.xuanze3 = this.extensionList[0].name;
              this.id_xuanze3 = this.extensionList[0].id;
              this.type_xuanze3 = this.extensionList[0].type;
              this.tempImg2 = this.extensionList[0].picurl;
            }
          }
          this.id = result.data.data.id;
          if (result.data.data.page_set === 1) {
            this.value = true;
          } else {
            this.value = false;
          }
          if (result.data.data.banner_set === 1) {
            this.value1 = true;
          } else {
            this.value1 = false;
          }
          if (result.data.data.module_set === 1) {
            this.value2 = true;
          } else {
            this.value2 = false;
          }
          if (result.data.data.extension_set === 1) {
            this.value3 = true;
          } else {
            this.value3 = false;
          }
          for (var i = 0; i < this.list.length; i++) {
            if (result.data.data.color === this.list[i].color) {
              this.yan = this.list[i].id;
            }
          }
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('查询设置信息失败：' + err);
        });
    },

    guanli(e) {
      // console.log(e)
      this.xuanze1 = e.name;
      this.id_xuanze1 = e.id;
      this.type_xuanze1 = e.type;
      this.tempImg = e.picurl;
    },

    guanli1(e) {
      // console.log(e, 'guanli1')
      this.xuanze2 = e.name;
      this.id_xuanze2 = e.id;
      this.type_xuanze2 = e.type;
      this.tempImg1 = e.picurl;
    },

    guanli2(e) {
      // console.log(e)
      this.xuanze3 = e.name;
      this.id_xuanze3 = e.id;
      this.type_xuanze3 = e.type;
      this.tempImg2 = e.picurl;
    },

    guanli4(e) {
      this.xcx_gh = e.name;
      this.xcx_gh_id = e.id;
    },

    // 修改颜色
    bianse(index) {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/mini/miniInfo/updateMiniInfoColor',
        method: 'POST',
        data: {
          id: this.id,
          color: index.color,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.yan = index.id;
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('修改颜色失败：' + err);
        });
    },

    // 界面修改开启
    updateMiniInfoPageSet() {
      if (this.value === true) {
        this.values = 1;
      } else {
        this.values = 0;
      }
      // console.log(this.value)
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/mini/miniInfo/updateMiniInfoPageSet',
        method: 'POST',
        data: {
          id: this.id,
          page_set: this.values,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('界面修改开启失败：' + err);
        });
    },

    // banner开启
    // updateMiniInfoBannerSet() {
    //   if (this.value1 === true) {
    //     this.value1s = 1;
    //   } else {
    //     this.value1s = 0;
    //   }
    //   // console.log(this.value)
    //   let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
    //   let pro = this.$http({
    //     url: '/mini/miniInfo/updateMiniInfoBannerSet',
    //     method: 'POST',
    //     data: {
    //       id: this.id,
    //       banner_set: this.value1s,
    //     },
    //     headers: {
    //       Authorization: 'Bearer ' + token,
    //     },
    //   });
    //   pro
    //     .then((result) => {
    //       // console.log(result)
    //       if (result.data.code !== 0) {
    //         return this.$message.error(result.data.message);
    //       }
    //     })
    //     .catch((err) => {
    //       // console.log(err)
    //       return this.$message.error('banner开启失败：' + err);
    //     });
    // },
    // 功能块开启
    // updateMiniInfoModuleSet() {
    //   if (this.value2 === true) {
    //     this.value2s = 1;
    //   } else {
    //     this.value2s = 0;
    //   }
    //   // console.log(this.value)
    //   let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
    //   let pro = this.$http({
    //     url: '/mini/miniInfo/updateMiniInfoModuleSet',
    //     method: 'POST',
    //     data: {
    //       id: this.id,
    //       module_set: this.value2s,
    //     },
    //     headers: {
    //       Authorization: 'Bearer ' + token,
    //     },
    //   });
    //   pro
    //     .then((result) => {
    //       // console.log(result)
    //       if (result.data.code !== 0) {
    //         return this.$message.error(result.data.message);
    //       }
    //     })
    //     .catch((err) => {
    //       // console.log(err)
    //       return this.$message.error('功能块开启失败：' + err);
    //     });
    // },
    // 扩展块开启
    // updateMiniInfoExtensionSet() {
    //   if (this.value3 === true) {
    //     this.value3s = 1;
    //   } else {
    //     this.value3s = 0;
    //   }
    //   // console.log(this.value)
    //   let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
    //   let pro = this.$http({
    //     url: '/mini/miniInfo/updateMiniInfoExtensionSet',
    //     method: 'POST',
    //     data: {
    //       id: this.id,
    //       extension_set: this.value3s,
    //     },
    //     headers: {
    //       Authorization: 'Bearer ' + token,
    //     },
    //   });
    //   pro
    //     .then((result) => {
    //       console.log(result);
    //       if (result.data.code !== 0) {
    //         return this.$message.error(result.data.message);
    //       }
    //     })
    //     .catch((err) => {
    //       // console.log(err)
    //       return this.$message.error('扩展块开启失败：' + err);
    //     });
    // },

    addBanner_1() {
      this.addBanner_s = true;
    },

    quxiao() {
      this.addBanner_s = false;
    },

    // banner图片添加
    addBanner() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/mini/miniBanner/addBanner',
        method: 'POST',
        data: {
          orgid: orgid,
          name: this.forms2.banner_name,
          miniid: this.xcx_id,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          console.log(result);
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          // console.log(this.forms2.banner_name)
          for (var i = 0; i < this.bannerList.length; i++) {
            if (this.forms2.banner_name === this.bannerList[i].name) {
              return this.$message.error('轮播图名称已存在!!!');
            }
          }
          this.addBanner_s = false;
          this.getMiniBannerByOrgId();
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('banner图片添加失败：' + err);
        });
    },
    getMiniBannerByOrgId() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/mini/miniBanner/getMiniBannerByOrgId/' + orgid,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.bannerList = result.data.data;
          for (var i = 0; i < this.bannerList.length; i++) {
            // console.log(this.bannerList[i].name)
            this.xuanze1 = this.bannerList[i].name;
            this.id_xuanze1 = this.bannerList[i].id;
            this.type_xuanze1 = this.bannerList[i].type;
            this.tempImg = this.bannerList[i].picurl;
          }
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('banner图片获取失败：' + err);
        });
    },

    // banner图片更换
    modificatio1() {
      this.loading_1 = true;
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/mini/miniBanner/updateBanner',
        method: 'POST',
        data: {
          id: this.id_xuanze1,
          miniid: this.xcx_id,
          orgid: orgid,
          picurl: this.tempImg,
          type: this.type_xuanze1,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code !== 0) {
            this.loading_1 = false;
            return this.$message.error(result.data.message);
          }
          this.loading_1 = false;
          return this.$message.success(result.data.message);
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('banner图片更换失败：' + err);
        });
    },

    // 功能块图片更换
    modificatio2() {
      this.loading_2 = true;
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/mini/miniModule/updateModule',
        method: 'POST',
        data: {
          id: this.id_xuanze2,
          miniid: this.xcx_id,
          orgid: orgid,
          picurl: this.tempImg1,
          type: this.type_xuanze2,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code !== 0) {
            this.loading_2 = false;
            return this.$message.error(result.data.message);
          }
          this.loading_2 = false;
          return this.$message.success(result.data.message);
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('功能块图片更换失败：' + err);
        });
    },

    // // 扩展块图片更换
    // modificatio3() {
    //   this.loading_3 = true;
    //   let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
    //   let orgid = window.sessionStorage.getItem('orgid');
    //   let pro = this.$http({
    //     url: '/mini/miniExtension/updateExtension',
    //     method: 'POST',
    //     data: {
    //       id: this.id_xuanze3,
    //       miniid: this.xcx_id,
    //       orgid: orgid,
    //       picurl: this.tempImg2,
    //       type: this.type_xuanze3,
    //     },
    //     headers: {
    //       Authorization: 'Bearer ' + token,
    //     },
    //   });
    //   pro
    //     .then((result) => {
    //       // console.log(result)
    //       if (result.data.code !== 0) {
    //         this.loading_3 = false;
    //         return this.$message.error(result.data.message);
    //       }
    //       this.loading_3 = false;
    //       return this.$message.success(result.data.message);
    //     })
    //     .catch((err) => {
    //       // console.log(err)
    //       return this.$message.error('扩展块图片更换失败：' + err);
    //     });
    // },
  },
};
</script>

<style lang="less">
.mains {
  .xiaoqu {
    .grid-content {
      .xcx_genghuan {
        .el-form-item i img {
          left: -100px !important;
        }
        .el-form-item {
          margin-left: 25px;
          .el-dropdown .el-button--primary {
            width: 360px !important;
          }
          .el-icon--right {
            position: absolute;
            top: 7px;
            left: 300px;
          }
        }
      }
    }
  }
}

.xcxgh {
  font-size: 12px;
  margin-left: 12px;
  margin-bottom: 30px;
  position: relative;
  .xcx_mc {
    font-size: 15px;
    font-weight: bold;
    margin: 20px 0 10px 0;
    color: #333;
    display: flex;
    align-items: center;
  }
  .xcx_xq {
    position: relative;
    img {
      width: 20px;
      height: 20px;
      box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
    }
    span {
      position: absolute;
      top: 2px;
      left: 30px;
      color: #666;
    }
  }
  .xcx_an {
    // left: 200px;
    margin-left: 30px;
    button {
      width: 90px;
      height: 28px;
      font-size: 12px !important;
      line-height: 28px;
      padding: 0;
      border-radius: 17px;
    }
  }
}

.huanse {
  color: #ccc;
  font-size: 12px;
  margin-left: 12px;
  // span {
  //   color: #00a6e6;
  // }
}
.kaiqi {
  margin: 20px 0 0 10px;
  font-size: 16px;
  font-weight: bold;
  color: #333;
  .el-switch {
    margin-right: 16px;
  }
}

.right {
  padding-left: 10px;

  .avatar {
    width: 450px;
    height: 250px;
    display: block;
  }
  .avatar1 {
    width: 250px;
    height: 250px;
    display: block;
  }

  .queding_xuigai {
    .el-button--primary {
      width: 260px !important;
      height: 40px !important;
      font-size: 16px !important;

      margin-top: 30px;
    }
  }

  .qiyong {
    color: #ccc;
    font-size: 14px;
    margin-left: 20px;
    span {
      font-size: 16px;
      color: #333;
      padding: 0 20px 0 10px;
    }
  }

  .shangchuan_lbt {
    margin: 30px 0 !important;
    .el-form-item__label {
      position: relative;
      bottom: -220px;
    }
    .lbt_shang {
      top: 12.26042vw !important;
    }
    .lbt_item,
    .el-form-item__content {
      line-height: 0;
    }
    .genghuan_lbt {
      display: flex !important;
      position: absolute;
      bottom: 10px;
      left: 470px;
      padding: 8px 0 0 20px;
    }
    .genghuan_gnk {
      display: flex !important;
      position: absolute;
      bottom: 10px;
      left: 270px;
      padding: 8px 0 0 20px;
    }
    .lbt_btn {
      width: 99px !important;
      height: 28px !important;
      font-size: 12px !important;
    }
    .lbt_span1 {
      font-size: 14px;
      color: #666;
      margin: 0 0 14px 135px;
    }
  }

  .tabs_1 {
    .zi_xuigai {
      font-size: 16px;
      color: #333;
      margin-top: 12px;
      border-bottom: 1px dashed #ccc;
      padding-bottom: 27px;
      span {
        font-size: 13px;
        color: #ccc;
      }
    }

    .form_1_1 {
      margin-left: 0;
      .el-form-item {
        margin-bottom: 8px;
        i {
          img {
            position: absolute;
            top: 0.26042vw;
            left: -94px;
          }
        }
        .el-button--primary:hover {
          border: 1px solid #0094ce;
        }

        .xuanze1 {
          position: relative;
          top: 0;
          left: 0;
          span {
            position: absolute;
            top: 0;
            left: 20px;
            line-height: 34px;
          }
        }

        .lbt_i_img {
          position: relative;
          left: 450px;
        }
        .el-icon--right {
          position: absolute;
          top: 12px;
          left: 500px;
        }

        .el-dropdown .el-button--primary {
          width: 560px;
          overflow: hidden;
        }
        .el-input__inner {
          color: #666;
        }

        .tianjia_banner {
          width: 90px;
          height: 30px;
          font-size: 12px;
          line-height: 4px;
          padding-left: 14px;
          border-radius: 0;
          position: absolute;
          top: 6px;
          span {
            span {
              font-size: 16px;
            }
          }
        }
      }
      .el-form-item__label {
        padding: 0 17px 0 0;
        color: #333333;
      }
      input::-webkit-input-placeholder,
      textarea::-webkit-input-placeholder {
        color: #666 !important;
      }
      .genggai {
        position: absolute;
        margin: -35px 0 0 248px;
        color: rgb(224, 9, 9);
        font-size: 10px;
        // top: 97px;
        // right: 80px;
      }
      .el-dropdown .el-button--primary {
        width: 90px;
        height: 36px;
        line-height: 28px;
        font-size: 12px;
        color: #666666;
        background-color: #fff;
        border-color: #ccc;
        border-radius: 3px;
        box-shadow: none;
      }
    }

    .qiehuan_lbt {
      margin: 40px 0 0 0;
    }

    .el-tabs__active-bar {
      z-index: 0;
    }
    .el-tabs__item {
      padding: 0;
    }
    .el-tabs__active-bar {
      background: none;
    }
    .el-tabs__nav-wrap::after {
      background: none;
    }
    .el-tabs__item.is-active {
      color: #00a6e6;
    }
    .el-tabs__item:hover {
      color: #00a6e6;
    }
    #tab-0 {
      width: 388px !important;
      background: url(../../../assets/img/small-program-manage/daohang_1.png);
      background-size: cover;
    }
    .tab_1_1 {
      width: 388px !important;
      background: url(../../../assets/img/small-program-manage/daohang_1_1.png);
      background-size: cover;
    }
    #tab-1 {
      width: 388px !important;
      background: url(../../../assets/img/small-program-manage/daohang_2.png);
      background-size: cover;
    }
    #tab-2 {
      width: 369px !important;
      background: url(../../../assets/img/small-program-manage/daohang_3.png);
      background-size: cover;
    }
    .el-tabs__item {
      height: 38px;
      text-align: center;
    }
  }
}
.shouji_cx {
  img {
    width: 350px;
    height: 709px;
  }
}

.ysxz {
  .yanse1:first-child {
    margin-left: 6px;
  }
  .yanse {
    width: 60px;
    height: 60px;
    opacity: 1;
    border-radius: 15px;
    float: left;
    margin: 30px 0 65px 6px;
    span {
      font-size: 14px;
      float: left;
      position: relative;
      top: 13px;
      left: 9px;
    }
    .img1 {
      width: 60px;
      height: 60px;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 24px;
        height: 18px;
      }
    }
  }
  .yanse1 {
    margin-left: 44px;
  }
}

.dropdown_xcx {
  width: 360px;
  left: 844px !important;
  // margin-top: -20px;
  .el-dropdown-menu__item {
    width: 340px;
    padding-left: 20px !important;
  }
}

.dropdown_lbt {
  width: 560px;
  left: 801px !important;
  // margin-top: -20px;
  .el-dropdown-menu__item {
    width: 540px;
    padding-left: 20px !important;
  }
}

.wuzi {
  left: -105px !important;
}
.zi {
  background: #8138f4;
  box-shadow: 2px 2px 3px rgba(114, 46, 209, 0.5);
}
.hong {
  background: #f73c4e;
  box-shadow: 2px 2px 3px rgba(247, 60, 78, 0.5);
}
.lan {
  background: #00a6e6;
  box-shadow: 2px 2px 3px rgba(0, 166, 230, 0.5);
}
.huang {
  background: #ffc41f;
  box-shadow: 2px 2px 3px rgba(255, 207, 54, 0.5);
}
.bilan {
  background: #07d3cd;
  box-shadow: 2px 2px 3px rgba(7, 211, 205, 0.5);
}
.cheng {
  background: #ff6a36;
  box-shadow: 2px 2px 3px rgba(255, 106, 54, 0.5);
}
.lianlan {
  background: #3d7dfd;
  box-shadow: 2px 2px 3px rgba(61, 125, 253, 0.5);
}
.lv {
  background: #71d311;
  box-shadow: 2px 2px 3px rgba(121, 219, 35, 0.5);
}
</style>
